import React from 'react';
import { SubtitleContext } from '../../../contexts/SubtitleContext';
import { Accordion, AccordionPanel } from 'rc-easyui';
import FindAllView from '../../translations/objects/FindAllView';
import FindAllView_replace from '../../translations/objects/FindAllView_replace';
import FindAllView_input from '../../translations/objects/FindAllView_input';
import FindAllView_list from '../../translations/objects/FindAllView_list';
import FindFrameGap_list_list from '../../translations/objects/FindFrameGap_list';
import FindFrameCPS_list from '../../translations/objects/FindFrameCPS_list';
import DragHandleUtils from '../../../helper/DragHandleUtils';
import FindPosition_list from '../../translations/objects/FindPosition_list';
import FindFrame_list from '../../translations/objects/FindFrame_list';
import StyleCheckResultList from './StyleCheckResultList';
import FindShotChange_list from '../../translations/objects/FindShotChange_list';
import DataObj from '../../../class/DataObj';
import TimeUtils from '../../../helper/TimeUtils';
import StringUtils from '../../../helper/StringUtils';
import ShotChangeUtils from '../../../helper/ShotChangeUtils';

/**
 * 所有Find的檢查結果，右下角的顯示區域
 */

const FindResultGroup = ({ _WaveformView }) => {
  function NumberList(props) {
    const error = props.error;
    const listItems = error.map((obj, index) => {
      const { rowIndex, typeName, errorMessage } = obj;

      return (
        <li key={index.toString()}>
          <a
            onClick={() => {
              //moveCellSelect(index);
            }}
          >
            {' '}
            Line {rowIndex + 1} {errorMessage}
          </a>
        </li>
      );
    });

    return <ul>{listItems}</ul>;
  }

  return (
    <div className='custom-ui' style={{fontSize:'15pt'}}>
      {_WaveformView.state.isShowFindAllViewReplace === true ? (
        <FindAllView
          closefindAllView={() => {
            _WaveformView.setState({ isShowFindAllViewReplace: false });
          }}
          children={
            <SubtitleContext.Consumer>
              {(context) => (
                <FindAllView_replace
                  handleReplace={(type, user) => {
                    _WaveformView.handleReplace(type, user);
                  }}
                  //處理 往前或是往後尋找
                  handleFindAndReplaceSearch_Next={(moveType, user) => {
                    const tableData = _WaveformView.DataObjArray.getContent();
                    const targetString = user['findString'];
                    if (targetString !== null) {
                      //送入檢查,取得尋找結果
                      let replaceArray = [];

                      tableData.forEach(function (obj, index) {
                        let { SubtitleCaption } = obj;
                        if (SubtitleCaption.includes(targetString)) {
                          replaceArray.push({
                            targetTitle: SubtitleCaption,
                            type: 'SubtitleCaption',
                            rowIndex: index,
                          });
                        }
                      });

                      //找到出結果
                      if (replaceArray.length !== 0) {
                        //確認目前table的row位置
                        const tableMoveRow =
                          _WaveformView.props.findAndReplaceMove(
                            moveType,
                            replaceArray,
                            _WaveformView.props.transOperation
                              .findAndReplaceSelectRowCol,
                            _WaveformView.props.transOperation.tableColMapping
                          );
                      }
                    }
                  }}
                  tableMoveRow={(targetLocation) => {
                    _WaveformView.hotTableComponent.current.hotInstance.scrollViewportTo(
                      parseInt(targetLocation, 10),
                      0
                    );
                    _WaveformView.hotTableComponent.current.hotInstance.selectCell(
                      parseInt(targetLocation, 10),
                      'SubtitleCaption'
                    );
                  }}
                  context={context}
                />
              )}
            </SubtitleContext.Consumer>
          }
        />
      ) : null}

      {_WaveformView.state.isShowFindAllViewInput === true ? (
        <FindAllView
          closefindAllView={() => {
            _WaveformView.setState({ isShowFindAllViewInput: false });
          }}
          children={
            <div>
              <FindAllView_input
                handelFind={(user) => {
                  let newData = [];
                  let tableData = _WaveformView.DataObjArray.getContent();
                  let targetString = user['targetString'];

                  tableData.forEach(function (obj, index) {
                    let Memo = obj.Memo === null ? '' : obj.Memo;
                    let SubtitleCaption =
                      obj.SubtitleCaption === null ? '' : obj.SubtitleCaption;
                    let Source = obj.Source === null ? '' : obj.Source;
                    //
                    if (user['isCaseSensitivity'] === true) {
                      /** 大小寫要分開 不能混著判斷*/
                    } else {
                      /** 大小寫沒差*/
                      //console.log(`大小寫沒差`)
                      targetString = targetString.toLowerCase();
                      if (SubtitleCaption !== null) {
                        SubtitleCaption = SubtitleCaption.toLowerCase();
                      }
                      if (Memo !== null) {
                        Memo = Memo.toLowerCase();
                      }
                      if (Source !== null) {
                        Source = Source.toLowerCase();
                      }
                    }

                    //
                    if (user['isSubtitle'] === true) {
                      if (SubtitleCaption.includes(targetString)) {
                        newData.push({
                          targetTitle: SubtitleCaption,
                          type: 'SubtitleCaption',
                          rowIndex: index,
                        });
                      }
                    }

                    if (user['isMemo'] === true) {
                      if (Memo.includes(targetString)) {
                        newData.push({
                          targetTitle: Memo,
                          type: 'Memo',
                          rowIndex: index,
                        });
                      }
                    }

                    if (user['isSource'] === true) {
                      if (Source.includes(targetString)) {
                        newData.push({
                          targetTitle: Source,
                          type: 'Source',
                          rowIndex: index,
                        });
                      }
                    }
                  });

                  //顯示結果view
                  // findAllTargetData
                  _WaveformView.setState({ FindAllList: newData });
                  _WaveformView.setState({ isShowFindAllView_list: true });
                }}
              />
            </div>
          }
        />
      ) : null}

      {_WaveformView.state.isShowFindAllView_list === true ? (
        <FindAllView
          closefindAllView={() => {
            _WaveformView.setState({ isShowFindAllView_list: false });
          }}
          children={
            <FindAllView_list
              FindAllList={_WaveformView.state.FindAllList}
              setDoubleClick={(targetIndex) => {
                //灰框點擊兩下
                DragHandleUtils.setDoubleClick(_WaveformView, targetIndex);
              }}
            />
          }
        />
      ) : null}

      {_WaveformView.state.isShowFindPositionList === true ? (
        <FindAllView
          closefindAllView={() => {
            _WaveformView.setState({ isShowFindPositionList: false });
          }}
          children={
            <div>
              <FindPosition_list
                setFindAllSelectRowCol={_WaveformView.setFindAllSelectRowCol}
              />
            </div>
          }
        />
      ) : null}

      {/* style檢查結果 */}
      {_WaveformView.state.isShowExportErrorList === true &&
      _WaveformView.isEnableStyleCheck === true ? (
        <FindAllView
          closefindAllView={() => {
            _WaveformView.setState({ isShowExportErrorList: false });
          }}
          children={
            <div
              style={{
                overflow: 'scroll',
                height: `${window.innerHeight - 600}px`,
              }}
            >
              <StyleCheckResultList _WaveformView={_WaveformView} />
            </div>
          }
        />
      ) : null}

      {_WaveformView.state.isShowFindFrameList === true ? (
        <SubtitleContext.Consumer>
          {(context) => (
            <FindFrame_list
              _WaveformView={_WaveformView}
              context={context}
              setFindAllSelectRowCol={_WaveformView.setFindAllSelectRowCol}
              closefindAllView={() => {
                _WaveformView.setState({ isShowFindFrameList: false });
              }}
            />
          )}
        </SubtitleContext.Consumer>
      ) : null}

      {/*
            Frame Gap Error 的搜尋結果
                    */}
      {_WaveformView.state.isShowFindFrameGapList === true ? (
        <SubtitleContext.Consumer>
          {(context) => (
            <FindFrameGap_list_list
              context={context}
              setFindAllSelectRowCol={_WaveformView.setFindAllSelectRowCol}
              closefindAllView={() => {
                _WaveformView.setState({ isShowFindFrameGapList: false });
              }}
            />
          )}
        </SubtitleContext.Consumer>
      ) : null}

      {/*
            Shot Change Error 的搜尋結果
        */}
      {_WaveformView.state.isShowShotChangeList === true ? (
        <SubtitleContext.Consumer>
          {(context) => (
            <FindShotChange_list
              _WaveformView={_WaveformView}
              context={context}
              setFindAllSelectRowCol={_WaveformView.setFindAllSelectRowCol}
              playerSeek={(sec) => {
                _WaveformView.player.seek(sec);
              }}
              closefindAllView={() => {
                _WaveformView.setState({ isShowShotChangeList: false });
              }}
              changeRow={(ShotChangeObj) => {
                // _WaveformView.tableData;
                const targetIndex = ShotChangeObj.rowIndex;
                const data = _WaveformView.DataObjArray.getContent();
                let dataObj = new DataObj(data[targetIndex]);

                // 處理 sh
                dataObj.runShotChangeObjCheck(
                  data,
                  ShotChangeObj,
                  _WaveformView
                );

                _WaveformView.setIsEdit(true);

                // 在更新一次錯誤的
                _WaveformView.props.updateShotChangeData(
                  _WaveformView.DataObjArray.getContent(),
                  _WaveformView.shotchangeData
                );
              }}
              changeAll={async (ShotChangeObjList, isNeedFrameSplitCheck) => {
                const data = _WaveformView.DataObjArray.getContent();

                for (let i = 0; i < ShotChangeObjList.length; i++) {
                  const ShotChangeObj = ShotChangeObjList[i];

                  // _WaveformView.tableData;
                  const targetIndex = ShotChangeObj.rowIndex;
                  //let dataObj = new DataObj(data[targetIndex]);

                  // 處理 sh
                  _WaveformView.DataObjArray.getContent()[targetIndex].runShotChangeObjCheck(
                    data,
                    ShotChangeObj,
                    _WaveformView
                  );
                }

                

                await _WaveformView.saveData_update_EditTable_ITManPlayer_WaveGroup(
                  _WaveformView.DataObjArray.getContent()
                );
  
                await _WaveformView.setIsEdit(true);

                // 在更新一次錯誤的
                await _WaveformView.props.updateShotChangeData(
                  _WaveformView.DataObjArray.getContent(),
                  _WaveformView.shotchangeData
                );


                // 23-3-11
                // 把資料都拿來處理直接跑 adjust frame split ---------------------- start
                if (isNeedFrameSplitCheck == true) {
                  for (
                    let i = 0;
                    i < _WaveformView.DataObjArray.getContent().length;
                    i++
                  ) {

                    // const currentTC = _WaveformView.DataObjArray.getContent()[i];
                    const currentTC = new DataObj(
                      _WaveformView.DataObjArray.getContent()[i]
                    );

                    // 第一個不用判斷
                    if (i > 0) {
                      const lastIndex = i - 1;

                      // 上一個物件
                      const lastObj = data[lastIndex];

                      if (currentTC.In == '' || lastObj.Out == '') {
                        return;
                      }

                      // 取得距離
                      const distance = DataObj.getDistance(lastObj, currentTC);

                      if (
                        currentTC.In == lastObj.Out ||
                        Math.abs(distance) <
                          parseFloat(_WaveformView.StyleData.fFrameSplit)
                      ) {
                        // sh 的處理後，一次檢查，
                        // 如果在in-tc的上一個out 有重疊的情況發生的話就是備註 的in-tc也會往後調整2f
                        // In TC 要往後標準f (finalTimestring + 2)

                        //往右邊增加的目的地
                        const moveToRight_finalTimeString =
                          StringUtils.checkTimeString(
                            TimeUtils.useStringCountFrame(
                              currentTC.In,
                              TimeUtils.getFPS(),
                              parseFloat(_WaveformView.StyleData.fFrameSplit)
                            )
                          );

                        // 執行往右邊移動
                        currentTC.setInOut('In', moveToRight_finalTimeString);

                        await _WaveformView.DataObjArray.updateDataObj_by_index(
                          i,
                          currentTC
                        );
                      }
                    }
                  }

                  await _WaveformView.saveData_update_EditTable_ITManPlayer_WaveGroup(
                    _WaveformView.DataObjArray.getContent()
                  );
    
                  await _WaveformView.setIsEdit(true);
  
                  // 在更新一次錯誤的
                  await _WaveformView.props.updateShotChangeData(
                    _WaveformView.DataObjArray.getContent(),
                    _WaveformView.shotchangeData
                  );
                }
                
                // 把資料都拿來處理直接跑 adjust frame split ---------------------- end
              }}
              removeSC={async () => {
                let data = _WaveformView.DataObjArray.getContent();

                for (let i = 0; i < data.length; i++) {
                  let dataObj = data[i];
                  //rowIndex
                  dataObj.setIsIgnoreShotchange(false);
                  dataObj.setIsInShotChangeActive(false);
                  dataObj.setIsOutShotChangeActive(false);
                }

                // 在更新一次錯誤的
                await _WaveformView.props.updateShotChangeData(
                  _WaveformView.DataObjArray.getContent(),
                  _WaveformView.shotchangeData
                );

                await _WaveformView.saveData_update_EditTable_ITManPlayer_WaveGroup(
                  _WaveformView.DataObjArray.getContent()
                );

                await _WaveformView.setIsEdit(true);

                //更新EditTable表單資料
                await _WaveformView.props.updateEditTableData(
                  _WaveformView.DataObjArray.getContent()
                );

                await _WaveformView.hotTableComponent.current.hotInstance.render();
              }}
              ResetAll={async () => {
                let data = _WaveformView.DataObjArray.getContent();

                for (let i = 0; i < data.length; i++) {
                  let dataObj = data[i];
                  if (dataObj.isIgnoreShotchange === true) {
                    //rowIndex
                    dataObj.setIsIgnoreShotchange(false);
                    await _WaveformView.DataObjArray.updateDataObj_by_index(
                      i,
                      dataObj
                    );

                    const errObj =
                      _WaveformView.props.findOperation.findShotChangeErrorData.filter(
                        (obj) => obj.rowIndex === i
                      );

                    console.log('檢查1', i, errObj);

                    if (errObj.length > 0) {
                      console.log('檢查2', errObj[0].errorShotChangeTitle[0]);
                      dataObj.setShotChange(errObj[0].errorShotChangeTitle);
                    }
                  }
                  // findShotChangeErrorData
                }
                console.log(
                  _WaveformView.props.findOperation.findShotChangeErrorData
                );

                // 在更新一次錯誤的
                await _WaveformView.props.updateShotChangeData(
                  _WaveformView.DataObjArray.getContent(),
                  _WaveformView.shotchangeData
                );

                await _WaveformView.saveData_update_EditTable_ITManPlayer_WaveGroup(
                  _WaveformView.DataObjArray.getContent()
                );

                await _WaveformView.setIsEdit(true);

                //更新EditTable表單資料
                await _WaveformView.props.updateEditTableData(
                  _WaveformView.DataObjArray.getContent()
                );

                await _WaveformView.hotTableComponent.current.hotInstance.render();
              }}
            />
          )}
        </SubtitleContext.Consumer>
      ) : null}

      {/*
                                    Frame CPS Error 的搜尋結果
                                */}
      {_WaveformView.state.isShowFindFrameCPSList === true ? (
        <SubtitleContext.Consumer>
          {(context) => (
            <FindFrameCPS_list
              context={context}
              setFindAllSelectRowCol={_WaveformView.setFindAllSelectRowCol}
              closefindAllView={() => {
                _WaveformView.setState({ isShowFindFrameCPSList: false });
              }}
            />
          )}
        </SubtitleContext.Consumer>
      ) : null}
    </div>
  );
};

export default FindResultGroup;



// WEBPACK FOOTER //
// ./src/components/drogable/FindResult/FindResultGroup.js